import axiosInstance from '../api/axios';

export const cuentasService = {
    getAllCuentas: async () => {
        const response = await axiosInstance.get('/cuentas/admin/cuentas/');
        return response.data;
    },

    getCuentaDetail: async (id) => {
        const response = await axiosInstance.get(`/cuentas/admin/cuentas/${id}/`);
        return response.data;
    },

    updateCuenta: async (id, data) => {
        const response = await axiosInstance.patch(`/cuentas/admin/cuentas/${id}/`, data);
        return response.data;
    },

    deleteCuenta: async (id) => {
        await axiosInstance.delete(`/cuentas/admin/cuentas/${id}/`);
    }
};
